import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-hero-section',
  imports: [],
  templateUrl: './hero-section.component.html',
  styleUrl: './hero-section.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroSectionComponent {}
